export enum FirebaseCollections {
  USERS = 'users',
  CONFIGURATION = 'configuration',
  BEACH_PLANS = 'beachPlans',
  TEMP_BOOKINGS = 'tempBookings',
  COMPLETED_BOOKINGS = 'completedBookings',
  SPOT_AVAILABILITY_LOCKS = 'spotAvailabilityLocks',
  DAILY_ANALYTICS = 'dailyAnalytics',
  CUSTOMER_ANALYTICS = 'customerAnalytics',
}
